var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutcomeYellowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_11_16",
    "data-name": "Component 11 \\u2013 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_167072",
    "data-name": "Group 167072"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83154",
    "data-name": "Path 83154",
    d: "M40,0C71.046,0,80,8.954,80,40S71.046,80,40,80,0,71.046,0,40,8.954,0,40,0Z",
    fill: "#ffe532"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "arrow-right",
    transform: "translate(24.348 27.734)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_45",
    "data-name": "Line 45",
    x2: 21.638,
    transform: "translate(4.348 7.391)",
    fill: "none",
    stroke: "#1c2023",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_69",
    "data-name": "Line 69",
    x2: 25.985,
    transform: "translate(0 16.931)",
    fill: "none",
    stroke: "#1c2023",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5450",
    "data-name": "Path 5450",
    d: "M12,5,24.266,17.266,12,29.531",
    transform: "translate(7.039 -5)",
    fill: "none",
    stroke: "#1c2023",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutcomeYellowIcon);
export default __webpack_public_path__ + "static/media/outcomeYellow_icon.a143b9da838172d00114e6f622f985da.svg";
export { ForwardRef as ReactComponent };